// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MkkWofHVxPUQQfpqkF6B{background:red}\n", "",{"version":3,"sources":["webpack://./src/components/SampleComponent/SampleComponent.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAe","sourcesContent":[".error {\n  background: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": "MkkWofHVxPUQQfpqkF6B"
};
export default ___CSS_LOADER_EXPORT___;
